import type {
  CreateReportInput,
  ResolveReportInput,
  ReportQueueQuery,
  ReportQueueResponse,
  ReportItem,
  ReportAccess,
  ModeratorTeamResponse,
} from '../../schemas/reports.js';
import { buildQuery, type RequestFn } from '../http.js';

/**
 * Reports ("Жалобы"). Filing is open to any signed-in user; the queue +
 * resolve + team endpoints are authorized server-side (guild MANAGE_MESSAGES,
 * platform moderator, or root admin).
 */
export function makeReportsApi(request: RequestFn) {
  return {
    /** File a report on a message or a user. */
    createReport: (input: CreateReportInput) =>
      request<{ ok: true; id: string; deduped?: boolean }>('/api/reports', {
        method: 'POST',
        body: JSON.stringify(input),
      }),
    /** Which moderation surfaces may I open? */
    getReportAccess: () => request<ReportAccess>('/api/reports/access'),
    /** Read a moderation queue (guild or platform). */
    listReports: (query: ReportQueueQuery) =>
      request<ReportQueueResponse>(`/api/reports${buildQuery(query)}`),
    /** Resolve a report (review / action / dismiss). */
    resolveReport: (id: string, input: ResolveReportInput) =>
      request<{ ok: true; report: ReportItem }>(`/api/reports/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(input),
      }),
    // ── Moderation team (root admin only) ──
    listModerators: () => request<ModeratorTeamResponse>('/api/reports/moderators'),
    addModerator: (userId: string) =>
      request<{ ok: true }>('/api/reports/moderators', {
        method: 'POST',
        body: JSON.stringify({ userId }),
      }),
    removeModerator: (userId: string) =>
      request<void>(`/api/reports/moderators/${userId}`, { method: 'DELETE' }),
  };
}
